import { Button, ButtonRow } from '@op/opds.opux';
import React, { type FC } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './ActionButtonRow.module.scss';
import { CancelPurchaseButton } from '../CancelPurchaseButton';
import i18n from 'i18n';

interface Props {
  infoText?: string;
  primaryButton: JSX.Element;
}
export const ActionButtonRow: FC<Props> = ({ infoText, primaryButton }) => {
  const navigate = useNavigate();

  const onBackButtonClick = () => {
    navigate('/');
  };
  return (
    <div id='navigation-area-first-row' className={styles.column}>
      {infoText && <div className={styles.infoText}>{infoText}</div>}
      <ButtonRow>
        {primaryButton}
        <Button
          data-testid='return-and-edit-button'
          aria-label={`${i18n.t('backButtonText')}: ${i18n.t(
            'background.form.returnAndEditScreenReaderMessage'
          )}`}
          onClick={onBackButtonClick}>
          {i18n.t('backButtonText')}
        </Button>
        <CancelPurchaseButton />
      </ButtonRow>
    </div>
  );
};
